export default [
  {
    path: "/categorias",
    component: () => import("@/layout/Default"),
    children: [
      {
        name: "categorias_list",
        path: "",
        component: () => import("./pages/List"),
        meta: {
          breadcrumbs: [{ label: "Categorias", to: "categorias_list" }],
          permission: "categoria:view",
          title: "Categorias",
        },
      },
      {
        name: "categorias_create",
        path: "novo",
        component: () => import("./pages/Create"),
        meta: {
          breadcrumbs: [{ label: "Categorias", to: "categorias_list" }],
          permission: "categoria:create",
          title: "Categorias - Cadastro",
        },
      },
      {
        name: "categorias_edit",
        path: "editar/:id",
        component: () => import("./pages/Edit"),
        meta: {
          breadcrumbs: [{ label: "Categorias", to: "categorias_list" }],
          permission: "categoria:edit",
          title: "Categorias - Edição",
        },
      },
    ],
  },
];
